import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedCompany: null,
  companies: [],
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanies(state, action) {
      state.companies = action.payload;
    },
    setSelectedCompany(state, action) {
      state.selectedCompany = action.payload;
    },
  },
});

export const { setCompanies, setSelectedCompany } = companySlice.actions;
export default companySlice.reducer;
